import React from 'react';
import { Button } from 'antd';
import { CallIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useInteractionHandler, UserInteraction } from 'modules/global';

interface IProps {
  setOpen: (open: boolean) => void;
  id?: string;
  admissionStartDate?: string | null;
  admissionEndDate?: string | null;
  maxContractPrice?: string | null;
  minContractPrice?: string | null;
  file?: string | null;
  phone?: string;
}

const MainInformation: React.FC<IProps> = ({ setOpen, id, phone }) => {
  const t = useTranslations();
  const { onInteractionClick } = useInteractionHandler(id);

  return (
    <div className="rounded-xl bg-white p-3">
      <div className="h-25 max-w-45 relative mx-auto flex w-full items-center justify-center aspect-[1.95]">
        <Image src="/images/test-paper.webp" alt="TEST PAPER" title="Test varog`i" fill />
      </div>
      <div className="mt-4 space-y-2">
        <Link
          target="_blank"
          href={`tel:${phone}`}
          onClick={onInteractionClick(UserInteraction.PHONE_CLICK)}
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-gray-100 py-2.5 text-sm font-medium"
        >
          <CallIcon />
          {t('qongiroq_qilish')}
        </Link>
        <Button
          onClick={() => setOpen(true)}
          className="!py-4.5 !w-full !rounded-lg !border-transparent !bg-green-500 !text-base !text-white hover:!bg-green-600"
        >
          {t('Test_yechish')}
        </Button>
      </div>
    </div>
  );
};

export default MainInformation;
